import { statementPasswordFromDob } from "./statementPassword";

const cleanPassword = (value) =>
  String(value || "").replace(/\s+/g, "");

const recipientEmails = (value) =>
  String(value || "")
    .split(/[;,]/)
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);

export const resolveGroupStatementPassword = ({
  configuredPassword,
  statementRecipient,
  advisers = [],
} = {}) => {
  const savedPassword = cleanPassword(configuredPassword);
  if (savedPassword) {
    return {
      password: savedPassword,
      source: "group",
      name: "Group password",
    };
  }

  const advisersByEmail = new Map(
    advisers
      .map((adviser) => [
        String(adviser?.email || "").trim().toLowerCase(),
        adviser,
      ])
      .filter(([email]) => email),
  );

  for (const email of recipientEmails(statementRecipient)) {
    const adviser = advisersByEmail.get(email);
    if (!adviser) continue;
    const password =
      cleanPassword(adviser.statementPassword) ||
      statementPasswordFromDob(adviser.adviserDob || adviser.dob);
    if (!password) continue;
    return {
      password,
      source: "recipient",
      name: adviser.adviser || adviser.name || email,
    };
  }

  return { password: "", source: "fixed", name: "Fixed fallback" };
};
